import { createHttpClient } from '@adapters/HttpClient';
import { ProfitabilityApiAdapter } from '../adapters/ProfitabilityApiAdapter';
import type { ProfitabilityProductCostPayload } from '../models/Profitability';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const httpClient = createHttpClient(apiClientWH);
const adapter = new ProfitabilityApiAdapter(httpClient);

function invalidateProductCostQueries(qc: ReturnType<typeof useQueryClient>) {
  qc.invalidateQueries({ queryKey: ['profitability', 'product-costs'] });
  qc.invalidateQueries({ queryKey: ['profitability', 'products-without-cost'] });
  qc.invalidateQueries({ queryKey: ['profitability', 'summary'] });
  qc.invalidateQueries({ queryKey: ['profitability', 'by-product'] });
}

export const useCreateProductCost = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: ProfitabilityProductCostPayload) => adapter.createProductCost(body),
    onSuccess: () => invalidateProductCostQueries(qc),
  });
};

export const useUpdateProductCost = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: ProfitabilityProductCostPayload }) =>
      adapter.updateProductCost(id, body),
    onSuccess: () => invalidateProductCostQueries(qc),
  });
};

export const useDeleteProductCost = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => adapter.deleteProductCost(id),
    onSuccess: () => invalidateProductCostQueries(qc),
  });
};
